import React, { Fragment, useEffect, useState } from "react";
import { Button, ButtonGroup, SplitButton } from "react-bootstrap";
import DropdownMultiselect from "react-multiselect-dropdown-bootstrap";
import {
    Row,
    Col,
    Card,
    Table,
    Badge,
    Dropdown,
    ProgressBar,
} from "react-bootstrap";




import { FaUserLarge } from "react-icons/fa6";

import { getInsituteverifyByID } from "../../../services/adminApiService/insituteVerficationApi/InsituteVerficationApiService";
import { useParams } from "react-router-dom";
import InsituteVerficationMapping from "../../../utils/maping/InsituteVerficationMapping";

import RemarkModal from "../Individual/RemarkModal";
import CleardCard from "../Individual/CleardCard";
import NotCleardCard from "../Individual/NotCleardCard";
import { formatLable } from "../../../utils/colorAsperStatus";
import NotCleardOrganisation from "./NotCleardOrganisation";


const OrganizationVerficationForm = () => {
    const { id } = useParams();
    const [remarkshowModal, setRemarkshowModal] = useState(false);
    const [showremarkrCard, setshowremarkCard] = useState(true);
    const [verficationList, setVerficationList] = useState({});
    const [insituteVerifyList, setInsituteVerifyList] = useState([]);
    const [remarkdata, setRemarkdata] = useState('');
    const [currentRemarkId, setCurrentRemarkId] = useState(null);


    useEffect(() => {
        const fetchVerificationList = async () => {
            try {
                const response = await getInsituteverifyByID(id);
                
                setVerficationList(response?.data?.data);
            } catch (error) {
                console.error('Error fetching verification list:', error);
            }
        };

        fetchVerificationList();
    }, [id]);

    const isValidUrl = (string) => {
        try {
            new URL(string);
            return true;
        } catch (_) {
            return false;
        }
    };
    
    useEffect(() => {
        const storedRemarks = JSON.parse(localStorage.getItem(`remarks-${id}`)) || {};

        if (Object.keys(verficationList).length > 0) {
            const baseList = [
                { id: 1, label: "Name", value: verficationList?.name_of_legel_entity, key: "name_of_legel_entity", action: false, remark: storedRemarks[1] || "" },
                { id: 2, label: "Registration Number", value: verficationList?.registration_number, key: "Reg_No", action: false, remark: storedRemarks[2] || "" },
                { id: 3, label: "Date of Establishment", value: verficationList?.year_of_operation, key: "year_of_operation", action: false, remark: storedRemarks[3] || "" },
                { id: 4, label: "Type of Sports Institution", value: verficationList?.registration_number, key: "registration_number", action: false, remark: storedRemarks[4] || "" },
                { id: 5, label: "Country", value: verficationList?.country, key: "country", action: false, remark: storedRemarks[5] || "" },
                { id: 6, label: "State", value: verficationList?.state, key: "state", action: false, remark: storedRemarks[6] || "" },
                { id: 7, label: "City", value: verficationList?.city, key: "city", action: false, remark: storedRemarks[7] || "" },
                { id: 8, label: "Pincode", value: verficationList?.pincode, key: "Zip_Code", action: false, remark: storedRemarks[8] || "" },
                { id: 9, label: "Contact Phone Number", value: verficationList?.contact_person_contact, key: "contact_person_contact", action: false, remark: storedRemarks[9] || "" },
                { id: 10, label: "Contact Email Address", value: verficationList?.contact_person_email, key: "contact_person_email", action: false, remark: storedRemarks[10] || "" },
                { id: 11, label: "Website", value: verficationList?.website, key: "website", action: false, remark: storedRemarks[11] || "" },
                { id: 12, label: "Name of Representative", value: verficationList?.represntive_name, key: "represntive_name", action: false, remark: storedRemarks[12] || "" },
                { id: 13, label: "Representative of Role", value: verficationList?.represntive_role, key: "represntive_role", action: false, remark: storedRemarks[13] || "" },
                { id: 14, label: "Representative of Phone Number", value: verficationList?.represntive_phone, key: "represntive_phone", action: false, remark: storedRemarks[14] || "" },
                { id: 15, label: "Representative of Email", value: verficationList?.represntive_email, key: "represntive_email", action: false, remark: storedRemarks[15] || "" },
                { id: 18, label: "Sports Offered", value: verficationList?.sports_offered, key: "sports_offered", action: false, remark: storedRemarks[18] || "" },
                { id: 19, label: "Facilities Available", value: verficationList?.facilities, key: "facilities", action: false, remark: storedRemarks[19] || "" },
                { id: 20, label: "Achievements", value: verficationList?.achievements, key: "achievements", action: false, remark: storedRemarks[20] || "" },
                { id: 21, label: "Affiliated Organizations", value: verficationList?.affiliated_sport_body, key: "affiliated_sport_body", action: false, remark: storedRemarks[21] || "" },
                { id: 23, label: "Number of Members", value: verficationList?.club_member_count, key: "club_member_count", action: false, remark: storedRemarks[23] || "" },
                { id: 24, label: "Training Programs Offered", value: verficationList?.program_offered, key: "program_offered", action: false, remark: storedRemarks[24] || "" },
                { id: 25, label: "Facility Type", value: verficationList?.facility_type, key: "facility_type", action: false, remark: storedRemarks[25] || "" },
                { id: 26, label: "Sports Supported", value: verficationList?.sport_support, key: "sport_support", action: false, remark: storedRemarks[26] || "" },
                { id: 27, label: "Capacity", value: verficationList?.capacity, key: "capacity", action: false, remark: storedRemarks[27] || "" },
                { id: 28, label: "Available Equipment", value: verficationList?.available_equipment, key: "available_equipment", action: false, remark: storedRemarks[28] || "" },
                { id: 29, label: "Operating Hours", value: verficationList?.operation_hour, key: "operation_hour", action: false, remark: storedRemarks[29] || "" },
                { id: 30, label: "Additional Services", value: verficationList?.additional_services, key: "additional_services", action: false, remark: storedRemarks[30] || "" },
            ];
            if (verficationList.registration_docs && Array.isArray(verficationList.registration_docs)) {
                verficationList.registration_docs.forEach((doc, index) => {
                    console.log("doc===>",doc);
                    baseList.push({
                        id: 23 + index, // Assuming the IDs continue sequentially
                        label: doc.doc_name,
                        value: doc.doc_file, // Assuming you want to display the file or use doc_name
                        key: `registration_doc_${index + 1}`,
                        action: false,
                        remark: storedRemarks[23 + index] || ""
                    });
                });
            }
    
            setInsituteVerifyList(baseList);
            
        }
    }, [verficationList, id]);

    const handleRadioChange = (id) => {
        setCurrentRemarkId(id);
        setRemarkshowModal(true);
        setshowremarkCard(false);
    };


    
    const updateRemark = (remark) => {
        const updatedList = insituteVerifyList.map(item => {
            if (item.id === currentRemarkId) {
                return { ...item, remark };
            }
            return item;
        });

        setInsituteVerifyList(updatedList);

        const storedRemarks = JSON.parse(localStorage.getItem(`remarks-${id}`)) || {};
        storedRemarks[currentRemarkId] = remark;
        localStorage.setItem(`remarks-${id}`, JSON.stringify(storedRemarks));
    };


 




    return (
        <>
            <div className="row ">
                <Col lg={12} className="mb-3">
                    <Card style={{ height: 'auto' }}>
                        <div className="d-flex justify-content-between p-2">
                            <div className="mt-2">
                                <h4><span className="mx-2"><FaUserLarge className="text-primary" /></span><span className="mx-2">NAME OF Organisation :{verficationList?.name_of_organization}</span></h4>
                            </div>
                            <div>
                                <div><strong>User Type</strong></div>
                                <Button className="bg-primary py-1">{verficationList?.category_name}</Button>
                            </div>
                        </div>
                    </Card>




                </Col>

                <Col lg={12} className="mb-3">
                    <Card style={{ height: 'auto' }}>
                        <div className="d-flex justify-content-between p-2">
                            <div className="mt-2">
                                <h4><span className="mx-2 text-danger">Current Status:Form Verification is {verficationList?.status}</span></h4>
                            </div>

                        </div>
                    </Card>
                </Col>

            </div>
            <div className="row">
                <Col lg={12} className="mb-3">
                    <Card style={{ height: '35vh' }}>
                        <Card.Header>
                            <Card.Title className="text-danger">VERIFY PHOTO</Card.Title>
                        </Card.Header>
                        <Card.Body >
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th>Sr. No.</th>
                                        <th>Student Profile Photo</th>
                                        <th>Action</th>
                                        <th>Remarks</th>

                                    </tr>

                                </thead>
                                <tbody>
                                    <tr>
                                        <th>1</th>
                                        <th>Photo</th>
                                        <td>
                                            <div className="d-flex">
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input bg-success"
                                                        type="radio"
                                                        name="gridRadios"
                                                        value="option1"
                                                        defaultChecked
                                                    />



                                                </div>
                                                <div className="form-check mx-2">
                                                    <input
                                                        className="form-check-input bg-danger"
                                                        type="radio"
                                                        name="gridRadios"
                                                        value="option1"
                                                        checked={false}
                                                        onChange={(event) => handleRadioChange(event?.data?.id)}

                                                    />



                                                </div>
                                            </div>

                                        </td>


                                    </tr>

                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>


                    <Card className="mb-3" style={{ height: 'auto' }}>
                        <Card.Header>
                            <Card.Title className="text-danger">VERIFY FORM FIELDS & DOCUMENTS</Card.Title>
                        </Card.Header>
                        <Card.Body >
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th>Sr. No.</th>
                                        <th>Form Fields</th>
                                        <th>Action</th>
                                        <th>Remarks</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {insituteVerifyList
                                        .filter(data => data.value) 
                                        .map((data, index) => (
                                            <tr key={data.id}>
                                                <td>{index + 1}</td>
                                                <td>
                                                    <span style={{ color: "#886CC0" }} ><strong>{formatLable(data?.label)}</strong></span><br />
                                                    {isValidUrl(data.value) ? (
                                                        <img src={data.value} alt={data.label} style={{ maxWidth: "100px", height: "auto" }} />
                                                    ) : (
                                                        <span style={{ fontSize: "13px" }}>{data.value}</span>
                                                    )}
                                                </td>
                                                <td>
                                                    <div className="d-flex">
                                                        <div className="form-check">
                                                            <input
                                                                className="form-check-input bg-success"
                                                                type="radio"
                                                                name={`gridRadios-${data.id}`}
                                                                value="option1"
                                                                defaultChecked
                                                            />
                                                        </div>
                                                        <div className="form-check mx-2">
                                                            <input
                                                                className="form-check-input bg-danger"
                                                                type="radio"
                                                                name={`gridRadios-${data.id}`}
                                                                value="option1"
                                                                checked={false}
                                                                onChange={(event) => handleRadioChange(data?.id)}
                                                            />
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                {data.remark}
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>

                </Col>

            </div>
        
            <RemarkModal remarkshowModal={remarkshowModal} setRemarkshowModal={setRemarkshowModal} setRemarkdata={setRemarkdata} setVerficationList={setVerficationList} remarkdata={remarkdata} currentRemarkId={currentRemarkId}   updateRemark={updateRemark}/>


            {
                (verficationList?.status === "final_submit" || verficationList?.status === "ask_for_resubmit") ? (
                    showremarkrCard ? (
                        <CleardCard userType="2"/>
                    ) : (
                        <NotCleardOrganisation insituteVerifyList={insituteVerifyList} userType="2"/>
                    )
                ) : (verficationList?.status === "ongoing")? (
                    <Card className="text-center p-3"> 
                        <h3 className="text-danger">It seems that Institution has not started further registration Process!
</h3>
                    </Card>
                ):""
            }
        </>

    )
}

export default OrganizationVerficationForm;